import { LuMenu, LuX } from "react-icons/lu";

export default function Sidebar({ items, active, onSelect, isOpen, setIsOpen }) {
    return (
        <aside
            className={`
                bg-custom-green-ccard-1 rounded-xl shadow-sm h-[calc(100vh-7rem)]
                transition-all duration-300
                ${isOpen ? "w-64" : "w-16"}
            `}
        >
            {/* HEADER */}
            <header className="p-3 flex justify-end">
                <button
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    className={`text-white text-xl ${isOpen ? "left-3" : "left-1/2 -translate-x-1/2"}`}
                >
                    {isOpen ? <LuX /> : <LuMenu />}
                </button>
            </header>

            {/* NAV ITEMS */}
            <nav className="flex flex-col p-2 gap-2">
                {items.map(item => (
                    <button
                        key={item.id}
                        onClick={() => onSelect(item.id)}
                        className={`flex items-center p-2 rounded-lg transition
                            ${isOpen ? "justify-start gap-3" : "justify-center"}
                            ${active === item.id
                                ? "bg-white text-gray-800"
                                : "text-white hover:bg-slate-200 hover:text-gray-800"}
                        `}
                    >

                        <span className="text-xl">{item.icon}</span>

                        {/* Ocultar texto cuando esté cerrado */}
                        {isOpen && (
                            <span className="text-base font-medium whitespace-nowrap">
                                {item.name}
                            </span>
                        )}
                    </button>
                ))}
            </nav>
        </aside>
    );
}
